import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import PersonIcon from '@material-ui/icons/Person';
import EmailIcon from '@material-ui/icons/AlternateEmail';
import PhoneIcon from '@material-ui/icons/Phone';
import PasswordIcon from '@material-ui/icons/VpnKey';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

import AuthBody from '../AuthBody';
import AuthBodyTitle from '../AuthBodyTitle';
import AuthBodyTextFieldRow from '../AuthBodyTextFieldRow';
import AuthBodyTextField from '../AuthBodyTextField';
import AuthBodyConfirmation from '../AuthBodyConfirmation';
import AuthBodyButton from '../AuthBodyButton';
import { IconButton, InputAdornment, InputBase } from '@material-ui/core';

const propTypes = {
    setConfirmEmail: PropTypes.func.isRequired,
};

const useStyles = makeStyles((theme) => styles(theme));

function RegisterBody ({ setConfirmEmail }) {
    const classes = useStyles();
    const authenticity_token = document.querySelector('meta[name=\'csrf-token\']').getAttribute('content');

    const [redirectRoute, setRedirectRoute] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('');
    const [passwordRevealed, setPasswordRevealed] = useState(false);
    const [errors, setErrors] = useState({});

    function togglePasswordReveal () {
        setPasswordRevealed(!passwordRevealed);
    }

    function handleFormSubmit (e) {
        e.preventDefault();
        const searchParams = new URLSearchParams({
            authenticity_token: authenticity_token,
            utf8: '✓',
            commit: 'SIGN UP',
            'user[email]': email,
            'user[password]': password,
            'user[first_name]': firstName,
            'user[last_name]': lastName,
            'user[phone]': phone
        });
        fetch('/user', {
            method: 'POST',
            body: searchParams.toString(),
            headers: {
                'content-type': 'application/x-www-form-urlencoded'
            }
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success) {
                    setConfirmEmail(email);
                    setRedirectRoute('/user/confirmation_sent');
                } else {
                    setErrors(data.detail);
                }
            })
            .catch((err) => {
                setErrors(err.response.detail);
            });
    }

    return (
        <AuthBody onSubmit={handleFormSubmit}>
            <input type="hidden" name="authenticity_token" value={authenticity_token} />
            <input type="hidden" name="utf8" value="✓" />
            <input type="hidden" name="commit" value="SIGN UP" />
            { redirectRoute !== '' ? <Redirect to={redirectRoute} /> : null }
            <AuthBodyTitle
                variant="h1"
            >
                Create your <span className={classes.highlighted}>LandHawk</span> account
            </AuthBodyTitle>
            {/* <AuthBodyTitle>
                Create your free account
            </AuthBodyTitle> */}
            <div>
                <AuthBodyTextFieldRow
                    icon={<PersonIcon color="primary" />}
                    error={Boolean(errors.first_name) || Boolean(errors.last_name)}
                >
                    <div className={classes.halfColumns}>
                        <AuthBodyTextField
                            label="First Name"
                            // color="primary"
                            name="user[first_name]"
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                            error={Boolean(errors.first_name)}
                            helperText={Boolean(errors.first_name) ? 'First name ' + errors.first_name.join(', ') : null}
                        />
                        <AuthBodyTextField
                            label="Last Name"
                            name="user[last_name]"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            error={Boolean(errors.last_name)}
                            helperText={Boolean(errors.last_name) ? 'Last name ' + errors.last_name.join(', ') : null}
                        />
                    </div>
                </AuthBodyTextFieldRow>
                <AuthBodyTextFieldRow
                    icon={<EmailIcon color="primary" />}
                    error={Boolean(errors.email)}
                >
                    <AuthBodyTextField
                        label="Email"
                        name="user[email]"
                        value={email}
                        type="email"
                        onChange={(e) => setEmail(e.target.value)}
                        error={Boolean(errors.email)}
                        helperText={Boolean(errors.email) ? 'Email ' + errors.email.join(', ') : null}
                    />
                </AuthBodyTextFieldRow>
                <AuthBodyTextFieldRow
                    icon={<PhoneIcon color="primary" />}
                    error={Boolean(errors.phone)}
                >
                    <AuthBodyTextField
                        label="Phone number"
                        name="user[phone]"
                        value={phone}
                        type="tel"
                        onChange={(e) => setPhone(e.target.value)}
                        error={Boolean(errors.phone)}
                        helperText={Boolean(errors.phone) ? 'Phone ' + errors.phone.join(', ') : null}
                    />
                </AuthBodyTextFieldRow>
                <AuthBodyTextFieldRow
                    icon={<PasswordIcon color="primary" />}
                    error={Boolean(errors.password)}
                >
                    <AuthBodyTextField
                        label="Password"
                        type={!passwordRevealed ? 'password' : 'text'}
                        name="user[password]"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        classes={{ root: classes.endAdornmentIconButtonRoot }}
                                        onClick={togglePasswordReveal}
                                    >
                                        { passwordRevealed ? <VisibilityIcon color="primary" /> : <VisibilityOffIcon color="primary" /> }
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                        error={Boolean(errors.password)}
                        helperText={Boolean(errors.password) ? 'Password ' + errors.password.join(', ') : null}
                    />
                </AuthBodyTextFieldRow>
            </div>
            <AuthBodyConfirmation
                linkText="Log in"
                href="/user/login"
            >
                Already have a LandHawk account?
            </AuthBodyConfirmation>
            <AuthBodyButton
                type="submit"
            >
                Sign Up
            </AuthBodyButton>
        </AuthBody>
    );
}

const styles = (theme) => ({
    bigTitle: {
        fontSize: '50px',
        ['@media (max-height: 1100px)']: {
            fontSize: '40px'
        }
    },
    endAdornmentIconButtonRoot: {
        padding: 0
    },
    highlighted: {
        color: theme.palette.primary.light
    },
    halfColumns: {
        display: 'flex',
        columnGap: '15px'
    }
});

RegisterBody.propTypes = propTypes;

export default RegisterBody;